<template>
<div class="chapter">
<div class="inner_page">
<p class="normal2">We will use the full weight of the law to expose and root out corruption…When abuses like this begin to surface in the corporate world, it is time to reaffirm the basic values that make capitalism work. There can be no capitalism without conscience, no wealth without character.</p>
<p class="right1"><span><i>US President George W. Bush, demanding ‘new ethics of personal responsibility’ from American business leaders after a series of Wall Street scandals. 10 July, 2002</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?09d544c2